export function getRecommendedDataProvider(providerType) {
    switch (providerType) {
        case 'RecommendedFilesApi':
            return function () {
                return import(
                /* webpackChunkName: "rf-dataprovider" */
                './RecommendedFilesApi/getFilesApiDataProvider');
            };
        // TODO: add MicrosoftFeed implementation
        case 'MicrosoftFeedApi':
            return function () {
                return import(
                /* webpackChunkName: "" */
                './OfficeFeedApi/getOfficeFeedApiDataProvider');
            };
        default:
            return function () { return Promise.resolve(undefined); };
    }
}
//# sourceMappingURL=getRecommendedDataProvider.js.map